export interface LiveStatusElements {
  readonly updated: Pick<HTMLElement, 'textContent' | 'title'>;
  readonly dot: {
    readonly classList: Pick<DOMTokenList, 'add' | 'toggle'>;
  };
}

export interface LiveStatus {
  readonly secondsSinceUpdate: number | null;
  readonly failed: boolean;
  readonly dataAge: number | null;
  readonly staleAfterS: number;
  readonly stale?: boolean;
  readonly dataName: string;
}

// Render the live indicator from the polling and source-age state. A page's
// freshness limit governs both its last successful poll and its source data.
export function renderLiveStatus(elements: LiveStatusElements, status: LiveStatus): void {
  const { secondsSinceUpdate: seconds, failed, dataAge, staleAfterS, dataName } = status;
  if (seconds === null) {
    if (failed) {
      elements.updated.textContent = 'Waiting for train updates · retrying';
      elements.dot.classList.add('stale');
    }
    return;
  }
  const age = seconds < 3 ? 'Updated just now' : `Updated ${String(seconds)} s ago`;
  elements.updated.textContent = failed ? `Partial updates · ${age}` : age;
  elements.updated.title =
    dataAge === null ? '' : `${dataName} are ${String(dataAge)} s old; positions are extrapolated from them.`;
  elements.dot.classList.toggle(
    'stale',
    status.stale === true || seconds > staleAfterS || failed || (dataAge !== null && dataAge > staleAfterS),
  );
}
